<template>
  <login-message-box
    title="Access Denied"
    buttonLabel="Login"
    :action="handleLogin"
  >
    If you believe this is an error, please contact the system
    administrator or try logging in again.
  </login-message-box>
</template>

<script>
import { getAuthInstance } from "@/auth/authService";
import LoginMessageBox from "@/views/components/auth/LoginMessageBox";

export default {
  name: "AccessDenied",
  components: {
    LoginMessageBox,
  },
  methods: {
    handleLogin() {
      const auth = getAuthInstance();
      auth.logout();
    },
  },
};
</script>